



































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { UserInterface } from '@/types';
import ConfirmEmailNotification from '@/components/user/ConfirmEmailNotification.vue';
import TheAccountDropDownMenu from '@/components/user/account/TheAccountDropDownMenu.vue';
import { Route } from 'vue-router';

export default Vue.extend({
  components: { ConfirmEmailNotification, TheAccountDropDownMenu },
  name: 'Header',
  mounted() {
    this.changeShowHeader();
  },
  watch: {
    isShowHeader() {
      this.changeShowHeader();
    },
  },
  computed: {
    user(): UserInterface {
      return this.getUser;
    },
    pageTitle(): string {
      return this.$store.state.pageTitle;
    },
    ...mapGetters({
      getUser: 'getUser',
      showHeader: 'showHeader',
      initials: 'getInitials'
    }),
    isConfirmedEmail(): boolean {
      return this.getUser.isConfirmedEmail;
    },
    sidebarMini(): boolean {
      return this.$store.state.sideBarMini;
    },
    instanceRoute(): Route {
      return this.$route;
    },
    isShowHeader(): boolean {
      if (this.instanceRoute.name === 'Account') {
        return false;
      }
      return true;
    },
  },
  methods: {
    resendEmail() {
      this.$store.dispatch('resendConfirmEmail');
    },
    showMenu() {
      this.isShowMenu = !this.isShowMenu;
    },
    hideMenu() {
      this.isShowMenu = false;
    },
    changeShowHeader() {
      if (this.isShowHeader) {
        this.$store.commit('changeShowHeader', true);
      } else {
        this.$store.commit('changeShowHeader', false);
      }
    },
  },
  data() {
    return {
      isShowMenu: false,
    };
  },
});
